import classnames from 'classnames/bind'
import React from 'react'
import { PRODUCT_TYPES } from '~/lib/constants'

import Image, { ImageProps } from '~/components/UI/Image'

import { PreviewSource } from '~/providers/ProductPageProvider'

import { ProductHeaderProps } from '../ProductHeader'
import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ProductHeaderMediaProps {
  className?: string
  items?: ProductHeaderProps['media']
  keepMediaRatio?: ProductHeaderProps['keepMediaRatio']
  openPreview?(state: boolean): void
  inPopIn?: boolean
  handleZoom?(state: boolean): void
}

const IMAGE_SIZES = [{ breakpoint: 'lg', ratio: 23 / 60 }, { ratio: 1 }]
const LITTLE_IMAGE_SIZES = [{ ratio: 1 / 12 }]

export interface CustomizationPreviewProps {
  className?: string
  hasRatio?: boolean
  sources?: PreviewSource[]
  onClick?(): void
  sizesFromBreakpoints?: ImageProps['sizesFromBreakpoints']
}

// Discovered that akairos is returning different ratio images depending on the type of customization
const IMG_RATIOS = {
  [PRODUCT_TYPES.ENGRAVING]: 0.72413793,
  [PRODUCT_TYPES.LABEL]: 0.75585937,
  DEFAULT: 0.75,
}

export interface CustomizationPreviewProps {
  className?: string
  hasRatio?: boolean
  sources?: PreviewSource[]
  onClick?(): void
  sizesFromBreakpoints?: ImageProps['sizesFromBreakpoints']
}

export function CustomizationPreview({
  className,
  sources,
  hasRatio = true,
  sizesFromBreakpoints,
  onClick,
}: CustomizationPreviewProps) {
  const reworkedSources = Object?.values(sources ?? {}) ?? []

  return (
    <div className={cx(css.CustomizationPreview, className)} onClick={onClick}>
      {reworkedSources?.map((img, index) => (
        <React.Fragment key={`${img?.src}_desktop`}>
          {/*
            // this container is useful in mobile to keep the positions of label customization images
            // the height based on ratio allows correct overlapping of images in a restrained container
          */}
          <div
            className={cx(css.image, css.hideOnLargeScreen, {
              first: index === 0,
            })}
            style={{
              height: `${
                (100 * IMG_RATIOS.DEFAULT) / IMG_RATIOS[img?.type ?? 'DEFAULT']
              }%`,
            }}>
            <Image
              draggable="false"
              layout="fill"
              asPlaceholder={index === 0}
              sizesFromBreakpoints={sizesFromBreakpoints ?? IMAGE_SIZES}
              objectFit="cover"
              loader={null}
              src={img?.src}
            />
          </div>
          <Image
            className={cx(css.image, css.hideOnSmallScreen, {
              first: index === 0,
            })}
            draggable="false"
            layout="fill"
            sizesFromBreakpoints={sizesFromBreakpoints ?? IMAGE_SIZES}
            objectFit="cover"
            asPlaceholder={index === 0}
            objectPosition={hasRatio ? 'bottom center' : null}
            ratio={hasRatio ? IMG_RATIOS[img?.type ?? 'DEFAULT'] : null}
            loader={null}
            src={img?.src}
          />
        </React.Fragment>
      ))}
    </div>
  )
}
